
/**
 * --------------------------------------
 * Importamos los paquetes necesarios "ngx-socket-io" tambien nuestro "environments" y por último
 * "ngx-cookie-service",
 * ----------------------------------------
 */
 import { Socket, SocketIoConfig } from 'ngx-socket-io';
 import { CookieService } from 'ngx-cookie-service';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { config, Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { MessageModule } from '../modelo/message/message.module';
import { HttpClient } from '@angular/common/http';
import { ChatLocalesModule } from '../modelo/chatLocales/chatLocales';
 
 
@Injectable({
    providedIn: 'root'
  })

  export class ChatService{

    mensaje:MessageModule;
  
      private socket = io('http://62.171.172.148:3000');
      //private socket = io('http://localhost:3000');

      constructor(private http: HttpClient) { }
  
  
  
      joinRoom(data)
      {
          this.socket.emit('join',data);
      }
  
      listarLocales(id_pais) 
   {
 
     return this.http.get(environment.apiUrlMaxipan+"/chat.php?locales="+id_pais); 
    }
      newUserJoined()
      {
          let observable = new Observable<{user:String, message:String}>(observer=>{
              this.socket.on('new user joined', (data)=>{
                  observer.next(data);
              });
              return () => {this.socket.disconnect();}
          });
  
          return observable;
      }
  

      guardar(mensaje:MessageModule){
        console.log(environment.apiUrlMaxipan+"chat.php",JSON.stringify(mensaje));
       return this.http.post(environment.apiUrlMaxipan+"chat.php",JSON.stringify(mensaje)); 
      }

      leaveRoom(data){
          this.socket.emit('leave',data);
      }
  
      userLeftRoom(){
          let observable = new Observable<{user:String, message:String}>(observer=>{
              this.socket.on('left room', (data)=>{
                  observer.next(data);
              });
              return () => {this.socket.disconnect();}
          });
  
          return observable;
      }
  
      sendMessage(data)
      {
      
       
          this.socket.emit('message',data);
      }
  
      newMessageReceived(){
          let observable = new Observable<{user:String, message:String}>(observer=>{
              this.socket.on('new message', (data)=>{
                  observer.next(data);

              });
              return () => {this.socket.disconnect();}
          });
  
          return observable;
      }
      
  }